import { Box } from 'grommet'
import styled from 'styled-components'

export const Container  = styled(Box)`

  width: ${props => props.multipleItemsPresent ? '96px': '108px'};;
  margin-right: 32px;

  @media screen and (max-width: 992px) {
    margin-right: 16px;
  }
`
